// Plugins
import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

let mm = gsap.matchMedia();

// Components
import Slider from "../components/sliders.js";
import { Tabs } from "../components/tabs.js";
import { FloatLabel } from "../components/floating-label.js";
import { Accordion } from "../components/accordion.js";
import { AnimateIndicator } from "../components/animate-indicator.js";
import { ReadMore } from "../components/read-more.js";
import { TocHighlighter } from "../components/toc.js";
import { simulateClick } from "../tools/utils.js";

// document.addEventListener("DOMContentLoaded", (e) => {
	// Init components
	Tabs.init();
	FloatLabel.init();
	Accordion.init();
	AnimateIndicator.initAll();
	ReadMore.init();
	TocHighlighter.init();

	// Issue when submiting AJAX form -> Convert to vanilla if you DARE !!
	jQuery(document).bind("gform_post_render", function () {
		FloatLabel.init();
	});

	// GF : Step form
	let $steps_form_sec = document.getElementById("steps-form");
	if ($steps_form_sec) {
		jQuery(document).bind("gform_confirmation_loaded", function (event, form_id) {
			console.log(form_id);
			let form_msg_1 = $steps_form_sec.querySelector(".form-text");
			let form_msg_2 = $steps_form_sec.querySelector(".form-confirmation-text");

			form_msg_1.style.display = "none";
			form_msg_2.style.display = "block";
		});
	}

	// Custom : Open Skills
	const $skillTriggers = document.querySelectorAll(".skill-item");
	if ($skillTriggers.length) {
		const $skillMainPanel = document.querySelector(".hero-skills__main");
		$skillTriggers.forEach((trigger) => {
			trigger.addEventListener("click", (e) => {
				e.preventDefault();
				const target = e.currentTarget.querySelector("[data-panel]").dataset.panel;
				$skillMainPanel.classList.add("is-hidden");
				document.querySelector(`[data-skill="${target}"]`).classList.add("is-open");
				$skillMainPanel.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
			});
		});

		const $skillCloseButtons = document.querySelectorAll("[data-close]");
		$skillCloseButtons.forEach((btn) => {
			btn.addEventListener("click", (e) => {
				const target = e.currentTarget.dataset.close;
				$skillMainPanel.classList.remove("is-hidden");
				document.querySelector(`[data-skill="${target}"]`).classList.remove("is-open");
			});
		});
	}

	// Swiper : Slider Quotes
	const $quoteSlider = document.querySelector(".quote-slider .swiper");
	if ($quoteSlider) {
		Slider.initSwiper($quoteSlider, {
			slidesPerView: 1,
			loop: true,
			effect: "creative",
			creativeEffect: {
				prev: {
					shadow: true,
					translate: [0, 0, -400],
				},
				next: {
					translate: ["100%", 0, 0],
				},
			},
			navigation: {
				nextEl: $quoteSlider.parentNode.querySelector(".quote-slider-btn"),
			},
		});
	}

	// Swiper : Slider Full Page
	// TODO : Replace ID by class on selector
	const $fpSlider = document.querySelector("#fp-slider");
	if ($fpSlider) {
		Slider.initSwiper($fpSlider, {
			slidesPerView: 1,
			loop: true,
			effect: "creative",
			creativeEffect: {
				prev: {
					translate: [0, 0, -400],
					opacity: 0,
				},
				next: {
					translate: ["100%", 0, 0],
				},
			},
		});
	}

	// Swiper : Slider Blocks
	const $blocksSlider = document.querySelector(".blocks-slider");
	if ($blocksSlider) {
		Slider.initSwiper($blocksSlider, {
			slidesPerView: 1,
			navigation: {
				nextEl: $blocksSlider.querySelector(".swiper-button-next"),
				prevEl: $blocksSlider.querySelector(".swiper-button-prev"),
			},
			breakpoints: {
				// when window width is >= 640px
				640: {
					slidesPerView: 2,
					spaceBetween: 40,
				},
			},
		});
	}

	// Gsap : Floating round
	let round_plx_elts = gsap.utils.toArray(".plx-round");
	if (round_plx_elts) {
		round_plx_elts.forEach((round) => {
			gsap.timeline({
				scrollTrigger: {
					trigger: round.parentNode,
					start: "-80% 50%",
					end: "bottom 50%",
					scrub: 2,
					toggleActions: "play none none none",
					//markers: true,
				},
			}).from(round, {
				y: 60,
			});
		});
	}

	// Swiper : Slider Réalisations
	let $slider_showcase = document.querySelector(".showcase-slider");
	if ($slider_showcase) {
		let $slider_showcase_btn = document.querySelector(".showcase-slider-btn");
		let swiperShowcase = Slider.initSwiper($slider_showcase, {
			loop: true,
			centeredSlides: true,
			slidesPerView: 1.3,
			watchSlidesProgress: true,
			parallax: true,
			speed: 2000,
			navigation: {
				nextEl: $slider_showcase_btn,
			},
		});
		simulateClick($slider_showcase_btn);
	}

	let $showcase_items = gsap.utils.toArray(".showcase-slider__pic");
	$showcase_items.forEach((item) => {
		gsap.to(item.querySelector("figure"), {
			yPercent: item.dataset.yPercent,
			scrollTrigger: {
				trigger: item.parentElement,
				start: "top 50%",
				end: "bottom 50%",
				scrub: 2,
			},
		});
	});

	// Gsap Floating Tease Post
	mm.add("(min-width: 800px)", () => {
		let cards_news = gsap.utils.toArray(".tease-post");
		if (cards_news) {
			cards_news.forEach((card) => {
				let animateCards = gsap.timeline({
					scrollTrigger: {
						trigger: ".post-tease-ctn",
						scrub: true,
						start: "top 50%",
						end: "bottom 50%",
					},
				});

				animateCards.from(card, {
					yPercent: card.dataset.gsapY,
					ease: "none",
				});

				animateCards.to(card, {
					yPercent: card.dataset.gsapY * -1,
				});
			});
		}
	});
// });
